/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1CheckIcon16Solid = forwardRef('People1CheckIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M7 10.11c0-.581-.496-1.048-1.067-.939-1.6.308-3.308 1.154-3.796 3.436C1.975 13.363 2.627 14 3.4 14H6a1 1 0 0 0 1-1v-2.89Z" }),
        React.createElement("path", { d: "M15.707 10.707a1 1 0 0 0-1.414-1.414L11 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l1.859 1.859a1.2 1.2 0 0 0 1.697 0l3.858-3.859Z" })));
});
